// FYI: You may notice suppressing for enums, don't know why
// eslint configured that way
// TODO: resolve this errors
// TICKET: https://gousto.atlassian.net/browse/TG-6506

// eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
export enum TableItemType {
  Gousto,
  HelloFresh,
  MindfulChef,
}

// eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
export enum Currency {
  PoundSterling = '£',
}
